<div class="header">
  <div class="action">
    <div class="close" (click)="cancel()">
      <mat-icon svgIcon="cross"></mat-icon>
    </div>
  </div>
</div>

<div class="modal-header">
  <h3>{{ 'image-cropper-modal.title' | translate }}</h3>
</div>

<div class="modal-body">
  <canvas
    #canvas
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerUp($event)">
  </canvas>
  <p class="hint">{{ 'image-cropper-modal.hint' | translate }}</p>
</div>

<div class="modal-footer">
  <button class="button secondary" (click)="cancel()" [disabled]="isProcessing">
    {{ 'image-cropper-modal.cancel' | translate }}
  </button>
  <button class="button primary" (click)="confirmCrop()" [disabled]="isProcessing">
    {{ (isProcessing ? 'image-cropper-modal.processing' : 'image-cropper-modal.confirm') | translate }}
  </button>
</div>
